import { getCookie, setCookie } from '@src/utils/cookies';

const CID_COOKIE_NAME = '_cen_cid';

/**
 * Генератор псевдоуникальной куки для устройства.
 * Взяты принципы генарации для Google Analytics.
 * Мы сможем различать так разные устройства,
 * а авторизованность будет идти отдельным параметром
 * @link https://gist.github.com/kindy/35ccd6c60b650e7fd261
 */
const generateClientIdGA = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  function hd() {
    return Math.round(2147483647 * Math.random());
  }
  function la(a) {
    let b = 1,
      c = 0,
      d;
    if (a)
      for (b = 0, d = a.length - 1; 0 <= d; d--)
        (c = a.charCodeAt(d)),
          (b = ((b << 6) & 268435455) + c + (c << 14)),
          (c = b & 266338304),
          (b = 0 != c ? b ^ (c >> 21) : b);
    return b;
  }

  let c =
    window.navigator.userAgent +
    (document.cookie ? document.cookie : '') +
    (document.referrer ? document.referrer : '');
  let d = c.length;
  let e;
  for (e = window.history.length; 0 < e; ) {
    c += e-- ^ d++;
  }

  return [hd() ^ (la(c) & 2147483647), Math.round(new Date().getTime() / 1e3)].join('.');
};

/**
 *
 * Работает аналогично тому, что у яметрики называется ClientID, но не использует значение
 * из метрики или google analytics.
 *
 * @link https://yandex.ru/support/metrica/general/clientid-userid.html
 */
export const getOrSetCentraCid = (): string => {
  if (typeof window === 'undefined') return '';

  let cookie = getCookie(CID_COOKIE_NAME);
  if (!cookie) {
    cookie = generateClientIdGA();
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);

    setCookie(CID_COOKIE_NAME, cookie, { expires });
  }
  return cookie;
};
